export interface ChatConfig {
  passportUrl: string;
  chatUrl: string;
  centrifugoUrl: string;
  passportWebUrl: string;
  oauthClientId: string;
  hcaptchaSiteKey: string;
}

let _config: ChatConfig | null = null;

/**
 * Returns true if the app is running in a demo environment.
 * Detection: hostname contains "demo" (e.g. demo-chat.meridianhub.ru)
 * or chatUrl contains "demo".
 */
export function isDemo(): boolean {
  if (typeof window !== "undefined" && window.location.hostname.includes("demo")) {
    return true;
  }
  const config = getConfig();
  return config.chatUrl.includes("demo");
}

export function initConfig(config: ChatConfig) {
  _config = config;
}

export function getConfig(): ChatConfig {
  if (_config) return _config;
  // Fallback: read from NEXT_PUBLIC env vars (Next.js) or defaults
  return {
    passportUrl: (typeof process !== 'undefined' && process.env?.NEXT_PUBLIC_PASSPORT_URL) || "http://localhost:3091",
    chatUrl: (typeof process !== 'undefined' && process.env?.NEXT_PUBLIC_CHAT_URL) || "http://localhost:3096",
    centrifugoUrl: (typeof process !== 'undefined' && process.env?.NEXT_PUBLIC_CENTRIFUGO_URL) || "ws://localhost:8000/connection/websocket",
    passportWebUrl: (typeof process !== 'undefined' && process.env?.NEXT_PUBLIC_PASSPORT_WEB_URL) || "http://localhost:3090",
    oauthClientId: (typeof process !== 'undefined' && process.env?.NEXT_PUBLIC_OAUTH_CLIENT_ID) || "",
    hcaptchaSiteKey: "",
  };
}
